import React, { forwardRef, useRef } from 'react';
import styled, { css } from 'styled-components';
import { Transition } from 'react-transition-group';
import { mergeRefs } from './mergeRefs';
const Animation = styled.div `
  --animation-default-x: 0px;
  --animation-default-y: 0px;
  --animation-enter-x: 0px;
  --animation-enter-y: -8px;
  --animation-exit-x: 0px;
  --animation-exit-y: -8px;

  transition: opacity 0.2s, transform 0.2s;

  transform: translate(var(--animation-default-x), var(--animation-default-y)) translateZ(0);

  ${({ state }) => state === 'entering' &&
    css `
      opacity: 0;
      transform: translate(var(--animation-enter-x), var(--animation-enter-y)) translateZ(0);
    `}

  ${({ state }) => state === 'entered' &&
    css `
      opacity: 1;
      transform: translate(var(--animation-default-x), var(--animation-default-y)) translateZ(0);
    `}

  ${({ state }) => (state === 'exiting' || state === 'exited') &&
    css `
      opacity: 0;
      transform: translate(var(--animation-exit-x), var(--animation-exit-y)) translateZ(0);
    `}
`;
export const Fade = forwardRef((props, ref) => {
    const nodeRef = useRef(null);
    return (React.createElement(Transition, { nodeRef: nodeRef, innerRef: ref, in: props.show, timeout: {
            enter: props.timeoutEnter ?? props.timeout ?? 200,
            exit: props.timeoutExit ?? props.timeout ?? 200,
        }, onEnter: props.onEnter, onEntered: props.onEntered, onExit: props.onExit, onExited: props.onExited, unmountOnExit: true }, (state) => (React.createElement(Animation, { ref: mergeRefs([nodeRef, ref]), state: state, as: props.base, className: props.className }, props.children))));
});
//# sourceMappingURL=Fade.js.map